import React from 'react';
import Eyebrow from '../page/Eyebrow';
import { tie } from '../page/typography';
import KeyDates from './KeyDates';
import { bodyText } from './prose';

/**
 * Врізка з головним: абзац про обов'язок чинних ліцензіатів і шкала дат.
 *
 * Раніше весь вступ разом із переліком змін стояв в одній жовтій картці на
 * півтора екрана — попередження на весь текст переставало бути
 * попередженням, а на телефоні внутрішні відступи стискали рядок до трьох
 * десятків знаків. Тепер виділено лише те, заради чого статтю відкривають:
 * хто мав подати, що й до якого дня.
 */
const KeyPoint = ({ id = 'kliuchovi-daty', text, dates = [], className = '' }) => (
  <div className={`rounded-2xl border border-teal-100 bg-teal-50/40 p-5 sm:p-7 ${className}`}>
    <p className={`${bodyText} text-slate-800`}>{tie(text)}</p>

    {dates.length > 0 && (
      <div className="mt-6 pt-6 border-t border-teal-100">
        {/* Підпис, а не заголовок: вступ стоїть до першого h2 статті, і h3
            тут опинився б у структурі під «Змістом статті». */}
        <Eyebrow id={id} className="mb-5">
          Ключові дати
        </Eyebrow>
        <KeyDates dates={dates} labelledBy={id} />
      </div>
    )}
  </div>
);

export default KeyPoint;
